const MEDIA_TAGS_FRAGMENT = `fragment mediaTags on Tag {
    ... on GameTag {
      slug
      type
      title
      gamePk
    }
    ... on TaxonomyTag {
      slug
      type
      title
    }
    ... on InternalTag {
      slug
      type
      title
    }
    ... on TeamTag {
      type
      team {
        id
      }
    }
}`;

const ARTICLE_FIELDS_FRAGMENT = `fragment articleFields on Article {
    contentDate
    description
    headline
    slug
    blurb: summary
    templateUrl: thumbnail
    type
    tags {
      ... mediaTags
    }
}`;

const QUERY = `query getGamesByGamePks($gamePks: [Int], $locale: Language, $gameRecapTags: [String]!, $relatedArticleTags: [String]!, $contentSource: ContentSource) {
    getGamesByGamePks(gamePks: $gamePks) {
        gamePk
        gameDate
        content {
            videoContent(locale: $locale) {
                headline
                duration
                title
                description
                slug
                id: slug
                blurb
                guid: playGuid
                date: contentDate
                contentDate
                preferredPlaybackScenarioURL(preferredPlaybacks: ["hlsCloud", "mp4Avc"])
                playbacks: playbackScenarios {
                    name: playback
                    url: location
                }
                thumbnail {
                    templateUrl
                }
                tags {
                    ... mediaTags
                }
                }
                ... on GameContent {
                recapArticle: articleContent(locale: $locale, tags: $gameRecapTags, limit: 1, contentSource: $contentSource) {
                    ... articleFields
                }
                relatedArticles: articleContent(locale: $locale, tags: $relatedArticleTags, excludeTags: $gameRecapTags, limit: 5) {
                    ... articleFields
                }
            }
        }
    }
}`;

export const getGamesByGamePks =
    `${MEDIA_TAGS_FRAGMENT}
     ${ARTICLE_FIELDS_FRAGMENT}
     ${QUERY}`;
